import { firebaseApp } from '../firebase.js';
import { 
  getFirestore, 
  collection, 
  getDocs, 
  doc, 
  updateDoc, 
  setDoc, 
  getDoc,
  query,
  where,
  orderBy,
  limit
} from 'firebase/firestore';

export const updateExistingProfilesWithVerification = async () => {
  const db = getFirestore(firebaseApp);
  
  console.log('Starting update of existing profiles with verification status...');
  
  try {
    // Get all test results from both collections
    const skillsValidationResults = await getDocs(collection(db, 'skillsValidationResults'));
    const jobseekerResults = await getDocs(collection(db, 'jobseekerResults'));
    
    const allResults = [];
    
    // Process skills validation results
    skillsValidationResults.forEach(doc => {
      const data = doc.data();
      if (data.score && data.jobSeekerId) {
        allResults.push({
          id: doc.id,
          jobSeekerId: data.jobSeekerId,
          score: data.score,
          completedAt: data.completedAt
        });
      }
    });
    
    // Process jobseeker results
    jobseekerResults.forEach(doc => {
      const data = doc.data();
      if (data.score && data.jobSeekerId) {
        allResults.push({
          id: doc.id,
          jobSeekerId: data.jobSeekerId,
          score: data.score,
          completedAt: data.completedAt
        });
      }
    });
    
    console.log(`Found ${allResults.length} test results to process`);
    
    // Group results by jobSeekerId and find the highest score for each
    const bestScoresByUser = new Map();
    
    allResults.forEach(result => {
      const existing = bestScoresByUser.get(result.jobSeekerId);
      if (!existing || result.score > existing.score) {
        bestScoresByUser.set(result.jobSeekerId, {
          score: result.score,
          completedAt: result.completedAt
        });
      }
    });
    
    console.log(`Processing ${bestScoresByUser.size} unique users`);
    
    // Update profiles for users with scores >= 60%
    let updatedCount = 0;
    
    for (const [userId, bestScore] of bestScoresByUser.entries()) {
      if (bestScore.score >= 60) {
        try {
          const profileRef = doc(db, 'userProfiles', userId);
          const profileDoc = await getDoc(profileRef);
          
          const updateData = {
            skillsVerified: true,
            verificationScore: bestScore.score,
            verificationDate: bestScore.completedAt || new Date(),
            lastUpdated: new Date()
          };
          
          if (profileDoc.exists()) {
            // Update existing profile
            await updateDoc(profileRef, updateData);
          } else {
            // Create new profile with verification
            await setDoc(profileRef, {
              userId: userId,
              ...updateData,
              createdAt: new Date()
            });
          }
          
          updatedCount++;
          console.log(`Updated profile for user ${userId} with score ${bestScore.score}%`);
        } catch (error) {
          console.error(`Error updating profile for user ${userId}:`, error);
        }
      }
    }
    
    console.log(`Successfully updated ${updatedCount} profiles with verification status`);
    return { updated: updatedCount, total: bestScoresByUser.size };
    
  } catch (error) {
    console.error('Error updating existing profiles:', error);
    throw error;
  }
};

// Function to run the update (can be called from console or component)
export const runProfileUpdate = async () => {
  try {
    const result = await updateExistingProfilesWithVerification();
    console.log('Profile update completed:', result);
    return result;
  } catch (error) {
    console.error('Profile update failed:', error);
    return null;
  }
};

